// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"101":"1945d6ec","225":"9566afa3","286":"6d4012b2","628":"0ad29220","852":"1945d6ec"}[chunkId] + ".chunk.css";
};